<template>
	<div>
		<!-- Hidden input -->
		<input
			:id="id"
			v-model="checked"
			tabindex="-1"
			type="checkbox"
			:disabled="disabled"
			@focus="onFocus"
		/>

		<!-- Checkbox -->
		<div
			ref="div"
			:tabindex="disabled ? '-1' : '0'"
			@keydown.space="onSpacebarPress"
			@click="toggleCheckbox"
		>
			<slot v-if="checked">
				<!-- <i v-html="assets.iconChecked" /> -->
			</slot>
			<!-- <i v-if="indeterminate && !checked" v-html="assets.iconIndeterminate" /> -->
		</div>
	</div>
</template>

<script>
/** Check Muangthai settings.json for reference of variant */
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		id: {
			type: String
		},
		disabled: {
			type: Boolean,
			default: false
		},
		indeterminate: {
			type: Boolean,
			default: false
		},
		value: {
			type: [Boolean, String, Array]
		},
		customValue: {
			type: [Boolean, String, Array]
		}
	},

	data() {
		return {
			checked: false
		}
	},

	computed: {
		modelType() {
			if (typeof this.value === "boolean") return "boolean"
			else if (Array.isArray(this.value)) return "array"
			else return "stringOrNull"
		}
	},

	watch: {
		checked: {
			handler() {
				let emittedValue = null
				switch (this.modelType) {
					case "boolean":
						emittedValue = this.checked
						break
					case "array":
						if (this.checked && !this.value.includes(this.customValue)) {
							emittedValue = [...this.value, this.customValue]
						} else {
							emittedValue = this.value.filter(i => i !== this.customValue)
						}
						break
					case "stringOrNull":
						emittedValue = this.checked ? this.customValue : null
						break
				}
				this.$emit("input", emittedValue)
			},
			deep: true
		},
		value: {
			handler() {
				switch (this.modelType) {
					case "boolean":
						this.checked = this.value
						break
					case "array":
						this.checked = this.value.includes(this.customValue)
						break
					case "stringOrNull":
						this.checked = this.value === this.customValue
						break
				}
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		toggleCheckbox() {
			if (this.disabled) return
			this.checked = !this.checked
		},
		onSpacebarPress(e) {
			this.toggleCheckbox()
			this.$emit("keydown", e)
			/** Space on keydown will trigger scroll. We don't want that behavior */

			e.preventDefault()
		},
		onFocus() {
			this.$refs.div.focus()
		}
	}
}
</script>
